import React, { useState, useRef, useEffect } from 'react';
import './styles/Dropdown.scss';

interface DropdownProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const Dropdown: React.FC<DropdownProps> = ({ options, value, onChange, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleSelect = (option: string) => {
    onChange(option);
    setIsOpen(false);
  };

  const toggleDropdown = (e: any) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`dropdown ${className}`} ref={dropdownRef}>
      <button
        type='button'
        className='dropdown__toggle'
        onClick={toggleDropdown}
        aria-haspopup='listbox'
        aria-expanded={isOpen}
      >
        <span className='dropdown__selected'>{value}</span>
        <span className={isOpen ? 'fas fa-caret-up' : 'fas fa-caret-down'} />
      </button>

      {isOpen && (
        <ul className='dropdown__menu' role='listbox'>
          {options.map((option) => (
            <li
              key={option}
              className={`dropdown__item ${option === value ? 'dropdown__item--selected' : ''}`}
              onClick={(e) => {
                e.stopPropagation(); // Prevent event propagation
                handleSelect(option);
              }}
              role='option'
              aria-selected={option === value}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
